// Throttle function: Input as function which needs to be throttled and delay is the time interval in milliseconds
export function throttle(timer: ReturnType<typeof setTimeout> | undefined, func: Function, delay?: number): ReturnType<typeof setTimeout> | undefined {
  // If setTimeout is already scheduled, no need to do anything
  if (timer) {
    return timer;
  }

  // Schedule a setTimeout after delay seconds
  return setTimeout(function () {
    func();
  }, delay);
}
